'use client';

import { Locale } from '../../../../i18n-config';
import SectionLabel from '../home/SectionLabel';
import StepCards, { StepCardItem } from '../_shared/sections/StepCards';
import { useTranslation } from '@/i18n/client';
import React from 'react';
import { HiCloudArrowUp, HiPencilSquare } from 'react-icons/hi2';
import { HiPaperAirplane } from 'react-icons/hi';

type Props = {
  lang: Locale;
};

type Step = {
  key: 'step1' | 'step2' | 'step3';
  num: string;
  Icon: typeof HiCloudArrowUp;
};

const STEPS: Step[] = [
  { key: 'step1', num: '01', Icon: HiCloudArrowUp },
  { key: 'step2', num: '02', Icon: HiPaperAirplane },
  { key: 'step3', num: '03', Icon: HiPencilSquare },
];

const ESignatureHowItWorks = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <section
      className="px-6 py-24 lg:py-28"
      style={{
        background: '#0A0E27',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        color: '#F5F7FA',
      }}
    >
      <div className="mx-auto max-w-[1200px]">
        <SectionLabel num="02" label={t('ESignature/HowItWorks/badge')} />
        <h2
          className="font-bold tracking-tight"
          style={{
            fontSize: 'clamp(28px, 3.4vw, 48px)',
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            margin: '12px 0 14px',
            maxWidth: 820,
          }}
        >
          {t('ESignature/HowItWorks/title')}{' '}
          <span style={{ color: '#B4C1D8' }}>{t('ESignature/HowItWorks/headline_b')}</span>
        </h2>
        <p
          style={{
            color: '#B4C1D8',
            fontSize: 18,
            maxWidth: 720,
            lineHeight: 1.5,
            margin: '0 0 48px',
          }}
        >
          {t('ESignature/HowItWorks/subtitle')}
        </p>

        <StepCards
          accent="#A78BFA"
          showArrow
          steps={STEPS.map(
            ({ key, num, Icon }): StepCardItem => ({
              key,
              num,
              title: t(`ESignature/HowItWorks/${key}_title`),
              description: t(`ESignature/HowItWorks/${key}_description`),
              Icon,
            })
          )}
        />
      </div>
    </section>
  );
};

export default ESignatureHowItWorks;
